/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import axios from 'axios';
import * as qs from 'query-string';

export const newAxiosInstance = () =>
  axios.create({
    paramsSerializer: (params: any) => qs.stringify(params),
  });
